export const MARKETING_DIECUTS_PAGE_SIZE = 50;
